import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const CreateRulesComponentWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",

  width: "100%",
}));

export const Title = styled("span")(() => ({
  color: colors.gray600,
  textAlign: "center",

  fontFamily: "Manrope",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "32px",
}));

export const SubTitle = styled("span")(() => ({
  color: colors.gray600,
  textAlign: "center",

  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const ButtonWrapper = styled("div")(() => ({
  marginTop: "24px",
}));
